
<template>
    <div>
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-danger">
                    <div class="card-icon">
                        <md-icon>alarm</md-icon>
                    </div>
            </md-card-header>

            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">

                                <div class="md-layout-item md-small-size-100 md-medium-size-100 md-xlarge-size-50">
                                    
                                    <h1 class="page_title md-layout-item md-size-100">Notification</h1>
                                    <h3>{{notification.buildingName}}</h3>
                                    <p class="margin_bottom">Publish a message on the Tenant Website (optionally control when message is displayed using Start and/or End dates)</p>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Message
                                        </label>
                                        <div class="md-layout-item">
                                            <ValidationProvider name="Message" rules="required|min:5|max:120" v-slot="{ passed, failed }">
                                                <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                                    <md-textarea v-model="notification.notification" md-autogrow></md-textarea>
                                                    <span class="md-helper-text">Text for display on website (no more than 120 characters)</span>
                                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                                </md-field>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            Start
                                        </label>
                                        <div class="md-layout-item md-size-40">
                                            <md-datepicker v-model="notification.start" md-immediately>
                                            </md-datepicker>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-25 md-form-label">
                                            End
                                        </label>
                                        <div class="md-layout-item md-size-40">
                                            <md-datepicker v-model="notification.end" md-immediately>
                                            </md-datepicker>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>

                        <div class="stepper-buttons-wrap md-layout md-alignment-space-between">
                            <div class="md-layout-item md-alignment-top-right md-layout">
                                <md-button class="md-primary" @click="validatePageSaveOrAlert">Save</md-button>
                            </div>
                        </div>

                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import { extend } from "vee-validate";
    import { required, email, min } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';

    export default {
        components: {
            SlideYDownTransition
            , FadeTransition
            , Loader
        },
        data() {
            return {
                loading: true,
                notification: null
            }
        },
        methods: {
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this notification`;
                this.$notify({
                    timeout: 3500,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            done() {
                this.$router.push(`/notifications`);

                setTimeout(() => {
                    this.$notify({
                        timeout: 8500,
                        message: `Notification for <b>${this.notification.buildingName}</b> was saved`,
                        icon: "thumb_up",
                        horizontalAlign: "center",
                        verticalAlign: "top",
                        type: NotyTypes[NotyTypes.success],
                        animate: {
                            enter: 'animated fadeInDown',
                            exit: 'animated fadeOutUp'
                        }
                    });
                }, 600);
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";

                errorsArray.forEach((e) => {
                    if (e.length > 0) {
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });

                this.$notify({
                    timeout: 2500,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            async validatePageSaveOrAlert() {
                this.$refs.valObserver.validate().then(async success => {

                    if (!success) {

                        setTimeout(() => { //TODO: update vee validate timeout here is to ensure errors are there and correct https://github.com/logaretm/vee-validate/issues/2248#issuecomment-578229806
                            this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                        }, 100);

                        return;
                    }
                    else {
                        await Api.notifications.upsertNotification(this.notification);
                        this.done();
                    }
                });
            }
        },
        computed: {
            isEditMode() {
                return !Help.isNullOrUndef(this.notification) && Help.isGoodNumber(this.notification.buildingId);
            }
        },
        async created() {
            if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                this.notification = await Api.notifications.getNotification(this.$route.params.buildingId);
                this.loading = false;
            }
        }
    }
</script>
<style lang="scss">
</style>

<!--maybe should have used cref https://vuejs.org/v2/guide/components.html#Dynamic-Components-->